enum LisioIconNames {
  ECO = "eco",
  HELP = "help",
  LOGO = "logo",
  MAIN = "main",
  RIGHT_CARRET = "right_carret",
  SAFE_TRANS = "safe_trans",
  TRANS = "trans",
  TREE = "tree",

  CROSS = "cross",
  DEACTIVATE = "deactivate",
  HIPPO_AA = "hippo_aa",
  LOGO_LISIO = "logo_lisio",
  LOGO_LISIO_MONOCHROME = "logo_lisio_monochrome",
  LOGO_LISIO_MONOCHROME_NEW = "logo_lisio_monochrome_new",
  LOGO_LISIO_NEW = "logo_lisio_new",

  FR = "fr",
  EN = "en",
  EN_GB = "en_gb",
  EN_US = "en_us",
  ES = "es",
  IT = "it",
  DE = "de",
  JA = "ja",
  RU = "ru",
  ZH_CN = "zh_cn",
  ZH = "zh",
  AR = "ar",
  PT = "pt",
  PT_PT = "pt_pt",
  PT_BR = "pt_br",
  CA = "ca",
  KO = "ko",
  DA = "da",
  FI = "fi",
  CY = "cy",
  EL = "el",
  HE = "he",
  HI = "hi",
  NL = "nl",
  NO = "no",
  NB = "nb",
  SV = "sv",
  CS = "cs",
  TH = "th",
  TR = "tr",
  UK = "uk",
  VI = "vi",
  YI = "yi",
  LB = "lb",
  PS = "ps",
  BG = "bg",
  ET = "et",
  HU = "hu",
  LV = "lv",
  LT = "lt",
  PL = "pl",
  RO = "ro",
  SK = "sk",
  SL = "sl",
  ID = "id",
  OC = "oc",
  BR = "br",
  EU = "eu",
  CO = "co",
  MFE = "mfe",
}

interface LisioIcon {
  attributes: {
    xmlns: string;
    aria_hidden: boolean;
    width?: number;
    height?: number;
    viewBox: string;
    fill: string;
    stroke: string;
    style: {
      height?: string;
      width?: string;
    };
  };
  class?: string;
  content: string;
  fillChildren: boolean;
  strokeChildren: boolean;
}

export { LisioIconNames };

export type { LisioIcon };
